import styled from '@emotion/styled';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { H1 } from './oc-h';
import RichText from './oc-rich-text';
import Text from './oc-text';
import { bazaarvoiceUrl } from '../Bazaarvoice/BazzarvoiceReviews/useFetchBazzarvoiceReviews';
import { connectLocation } from '../location/LocationConnectors';
import { formatTotal, inPercent } from '../Bazaarvoice/Rating/utils';
import { RatingStarLine } from '../Bazaarvoice/RatingStarLine/index';
import { navigate } from '../helpers/sticky_nav';
import wrappedInRouter from '../wrappedInRouter';

// Styled Components
const HeroGrid = styled.div`
  @media screen and (min-width: 768px) {
    position: relative;
    width: 100%;
  }
`;

const HeroPageHeading = styled.div`
  padding: 0 15px;

  @media (min-width: 768px) {
    background: white;
    left: 0px;
    padding: 0 15px 15px 15px;
  }

  @media screen and (min-width: 1200px) {
    padding: 1px 30px 0 86px;
  }
`;

const PostHead = styled.span`
  color: #6d6d6d;
  display: block;
  font-family: 'OCRoboto', sans-serif;
  font-size: 16px;
  line-height: 16px;
  margin: 16px 0 0;
  text-transform: uppercase;

  @media (min-width: 1200px) {
    font-size: 18px;
    line-height: 21px;
  }
`;

const Ratings = styled.p`
  align-items: center;
  display: flex;
  gap: 10px;
  margin-top: 25px;
`;

const Stars = styled.div`
  display: inline-flex;
  flex-shrink: 0;
`;

const RatingsDescription = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
`;

const Hero = connectLocation(({
  prehead,
  h1,
  posthead,
  body,
  children,
  shingleLine,
  showRatings,
  t,
  ...props
}) => {
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState({});

  const history = useHistory();

  useEffect(async () => {
    if (!showRatings || !shingleLine) return;

    try {
      const params = new URLSearchParams({
        page: 1,
        per_page: 1,
      });
      params.append('filters[products][]', shingleLine);

      const response = await fetch(`${bazaarvoiceUrl()}?${params}`);
      const json = await response.json();
      setReviews({
        total: json.meta.summary.total_reviews,
        avg: json.meta.summary.average_star_rating,
      });
      setLoading(false);
    } catch (requestError) {
      console.log({ requestError });
    } finally {
      setLoading(false);
    }
  }, [showRatings, shingleLine]);

  const reviewsKey = 'ratings-reviews';

  const goToReviews = (e) => {
    navigate(reviewsKey);
    history.push(`#${reviewsKey}`);
    e.preventDefault();
  };

  return (
    <HeroGrid>
      <HeroPageHeading>
        {prehead && (
          <span className="prehead tier3">
            <Text content={prehead} />
          </span>
        )}
        <H1 className="tier3">
          <RichText content={h1} inline />
        </H1>
        {posthead && (
          <PostHead>
            <Text content={posthead} />
          </PostHead>
        )}
        {showRatings && shingleLine && (
          <Ratings>
            <Stars>
              <RatingStarLine percent={loading ? 0 : inPercent(reviews.avg)} outerSize={23} innerSize={20} />
            </Stars>
            {!loading && reviews.total !== undefined && (
              <RatingsDescription>
                <span
                  // eslint-disable-next-line react/no-danger -- translated copy carries markup
                  dangerouslySetInnerHTML={{
                    __html: t('shingles.reviews.summary', { avg: reviews.avg, total: formatTotal(reviews.total) }),
                  }}
                />
                <a href={`#${reviewsKey}`} onClick={e => goToReviews(e)}>
                  {t('shingles.reviews.read')}
                </a>
              </RatingsDescription>
            )}
          </Ratings>
        )}
      </HeroPageHeading>
    </HeroGrid>
  );
});

export default wrappedInRouter(Hero);
